import { HSLColor } from '@yola/yola-palette-generator';
import parseHslaColorString from './parse-hsla-color-string';
import parseTemplate from './parse-template';
import isCssVariable from '../verifiers/is-css-variable';

const parseColorValue = (cssStr) => {
  if (isCssVariable(cssStr)) return cssStr;
  const { h, s, l, a } = parseHslaColorString(cssStr);
  return new HSLColor(h, s, l, a);
};

const computeRuleset = (ruleset, context) =>
  Object.fromEntries(
    Object.entries(parseTemplate(ruleset, context)).map(([key, cssStr]) => [
      key,
      parseColorValue(cssStr),
    ])
  );

export default computeRuleset;
